import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  DetailsSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import {
  ApplicationInfoLoading,
  FeeInfoLoading,
  MaturityInfoLoading,
  NetValueInfoLoading,
  ProfitabilityInfoLoading,
  RiskInfoLoading,
  TaxInfoLoading,
  UnitPriceInfoLoading,
} from '../shared';

export const ListLoadingItemTablet: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack justifyContent="space-between" alignItems="center" w="full">
          <TextSkeleton w="60%" hasCaptions />
          <DetailsSkeleton />
        </HStack>
        <HStack justifyContent="space-between">
          <ApplicationInfoLoading w="1/4" />
          <RiskInfoLoading w="1/4" />
          <TaxInfoLoading w="1/4" />
          <ProfitabilityInfoLoading w="1/4" />
        </HStack>
        <HStack justifyContent="space-between">
          <MaturityInfoLoading w="1/4" />
          <UnitPriceInfoLoading w="1/4" />
          <FeeInfoLoading w="1/4" />
          <NetValueInfoLoading w="1/4" />
        </HStack>
        <HStack justifyContent="space-between" w="full">
          <VStack space="stack.quarck" w="45%">
            <HStack space="inline.quarck" alignItems="center">
              <UI.Text variant="semibold">Taxa</UI.Text>
              <UI.Text fontSize="xs">(Spread)</UI.Text>
            </HStack>
            <Stack pr="inline.nano">
              <InputSkeleton />
            </Stack>
          </VStack>
          <HStack w="2/4" space="inline.xxxs">
            <VStack space="stack.quarck" flex={1}>
              <UI.Text color="neutral.black" variant="semibold">
                Valor a aplicar
              </UI.Text>
              <VStack flex={1}>
                <InputSkeleton />
              </VStack>
            </VStack>
            <Stack justifyContent="flex-end" width="40px">
              <ButtonSkeleton borderRadius={BoxBorder.thick} />
            </Stack>
          </HStack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
